import { selectAuthUser } from '@/redux/reducers/auth.reducer'
import { useAppSelector } from '@/redux/rootReducer'
import { useCallback, useState } from 'react'
import { useEmergencyRoom } from './useEmergencyRoom'
import { isStaff } from '@/utils/type-guards'
import { useNavigate } from 'react-router-dom'

export function useLeaveEmergency(emergencyRoomId?: string) {
  const navigate = useNavigate()

  const [openLeaveEmergencyDialog, setOpenLeaveEmergencyDialog] = useState(false)

  const authUser = useAppSelector(selectAuthUser)
  const emergencyRoom = useEmergencyRoom(emergencyRoomId)

  const leaveEmergency = useCallback(() => {
    if (!authUser || !emergencyRoom || !isStaff(authUser)) return

    if (authUser.status === 'PDS') {
      if (emergencyRoom.currentConsultation) {
        setOpenLeaveEmergencyDialog(true)
        return
      }

      navigate('/')
      return
    }

    if (authUser.status === 'MEDECIN') {
      // This was causing issue to unattached a doctor from a consultation if he leaves before the consultation is over
      // if (emergencyRoom.currentConsultation ) {
      //   doctorLeavingRoomRequestHandler.dispatch(updateConsultation(emergencyRoom.currentConsultation, { medecin: null }))
      //   return
      // }

      navigate('/emergencies')
      return
    }
  }, [authUser, emergencyRoom])

  return { leaveEmergency, openLeaveEmergencyDialog, setOpenLeaveEmergencyDialog }
}
